import React from 'react'

import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'

import Button from 'components/landing-page/Button'
import { WhiteTextTypography, HighlightedTypography } from './Typography'

const PrimaryAttentionGrab = () => (
  <>
    <Grid item>
      <WhiteTextTypography variant="h3">Modern Software for Scrap Yards</WhiteTextTypography>
    </Grid>

    <Grid container item justifyContent="center">
      <Grid item xs={12} md={6} lg={6}>
        <WhiteTextTypography variant="h5">
          GreenSpark is building modern software for scrap yards to help you{' '}
          <HighlightedTypography variant="span" color="secondary">
            streamline operations
          </HighlightedTypography>
          ,{' '}
          <HighlightedTypography variant="span" color="secondary">
            save time and money
          </HighlightedTypography>
          , and{' '}
          <HighlightedTypography variant="span" color="secondary">
            scale your business
          </HighlightedTypography>
          .
        </WhiteTextTypography>
      </Grid>
    </Grid>

    <Grid item>
      <Link href="mailto:hello@greensparksoftware.com" underline="none">
        <Button size="large">Contact Us</Button>
      </Link>
    </Grid>
  </>
)

export default PrimaryAttentionGrab
